/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Components/CustomUi/warning/index.tsx
 * Papel: componente compartilhado congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Aviso } from "./styles"
import { faCircleCheck, faCircleExclamation, faCircleInfo, faCircleXmark, faInfo, faSkullCrossbones } from "@fortawesome/free-solid-svg-icons";

//PROPS
interface Props {
    children: React.ReactNode;
    type?: 'warning' | 'danger' | 'error' |'success' | 'info';
    style?: React.CSSProperties;
}

export const Warning: React.FC<Props> = ({ children, type, style }) => {

    function iconType() {
        switch (type) {
            case 'warning':
                return faCircleExclamation;
            case 'danger':
                return faSkullCrossbones;
            case 'error':
                return faCircleXmark;
            case 'success':
                return faCircleCheck;
            case 'info':
                return faCircleInfo;
            default:
                return faInfo;
        }
    }

    return (
        <Aviso data-type={type} style={style}>
            <FontAwesomeIcon icon={iconType()} />
            {children}
        </Aviso>
    )
}